module.exports = __webpack_public_path__ + "static/media/card-food-container.3f4b8f94.png";